// @ts-ignore
import Slider from './Slider';
// @ts-ignore
import MainNavigation from './MainNavigation';
// @ts-ignore
import ProductList from './ProductList';
// @ts-ignore
import Login from './Login';
// @ts-ignore
import Utilities from './Utilities';
// @ts-ignore
import DocumentList from './DocumentList';
// @ts-ignore
import DistributorList from './DistributorList';

export default function () {
    Slider();
    MainNavigation();
    ProductList();
    Login();
    Utilities();
    DocumentList();
    DistributorList();
}
